// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3rML6","footer":"ModalCreateQualiphyProcedure_footer__1dIgO","additionData":"ModalCreateQualiphyProcedure_additionData__30WkA"};